import React from "react";
import { useParams } from "react-router-dom";

export default function ProductionProjectLink({ projectNumber }) {
  const { instanceUniqueId } = useParams();
  const value = String(projectNumber ?? "").trim();
  const validProjectNumber = /^\d+$/.test(value) && /[1-9]/.test(value);

  if (!validProjectNumber) return <>–</>;
  if (!instanceUniqueId) return <>{projectNumber}</>;

  return (
    <a
      href={`/instance/${encodeURIComponent(instanceUniqueId)}/sales/orders/${encodeURIComponent(value)}/overview`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary"
      aria-label={`Open Sales Project ${value} overview (opens in a new tab)`}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {projectNumber}
    </a>
  );
}
